export const UPDATE_ESTADOS = "UPDATE_ESTADOS";
export const UPDATE_CIDADES = "UPDATE_CIDADES";